import { Button, Typography } from '@breetometer/components';
import { RemoveTeamMemberIcon, TeamMemberRoleIcon } from 'BreetAssets';
import { getTeamMemberRoleLabel, handleApiError, showToast } from 'BreetHelpers';
import { useDeleteTeamMemberByIdMutation } from 'BreetRedux';
import { useCallback } from 'react';

import type { IDeleteTeamMemberChild } from './DialogRemoveTeamMember.helpers';

const Child = ({ teamMemberData, modalApis }: IDeleteTeamMemberChild) => {
	const [deleteTeamMember, { isLoading }] = useDeleteTeamMemberByIdMutation();

	const onDeleteMember = useCallback(() => {
		if (!teamMemberData?.data?.id) {
			showToast('error', 'Team member not found');
			return;
		}

		deleteTeamMember(teamMemberData.data.id)
			.unwrap()
			.then(() => {
				modalApis.handleModalCloseAll();
			})
			.catch(handleApiError);
	}, [deleteTeamMember, teamMemberData?.data?.id, modalApis]);

	return (
		<div className='remove-team-member'>
			<RemoveTeamMemberIcon className='remove-team-member-icon' />
			<Typography as='h4'>Remove this Team Member?</Typography>

			<div className='profile'>
				<Typography as='h6'>{teamMemberData?.data?.fullName}</Typography>
				<Typography>{teamMemberData?.data?.email}</Typography>
				<TeamMemberRoleIcon text={getTeamMemberRoleLabel(teamMemberData?.data?.role ?? 'owner')} />
			</div>

			<div className='cta-remove'>
				<Button
					onClick={onDeleteMember}
					isLoading={isLoading}
				>
					Yes, Remove
				</Button>
			</div>
		</div>
	);
};

export default Child;
